import styled from 'styled-components'

export const WrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const LinkNotPublished = styled.div`
  padding-top: 8px;
`

export const PublishedButtonWrap = styled.div`
  max-width: 153px;
`

export const EmptyButtonWrap = styled.div`
  max-width: 168px;
`
